<div class="d-flex flex-column table-container background-container mt-4">

  <div class="header-box">
    <div class="fixed-with-coloumn p-2" *ngFor="let name of columnDisplayNames">
      {{ name }}


    </div>
  </div>

  <div class="table-body-container">

    <div class="d-flex flex-column gap-1" *ngFor="let item of data">
      @if(TableFor==='ADMIN_PROVIDER' || TableFor==='ADMIN_INSURER' || TableFor==='ADMIN_DISTRIBUTOR' ){
      <div class="information-box border-colour" (click)="openAdminProile.emit(item.userId)">
        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{ item.firstName }} {{ item.lastName }}</div>
            @if ( TableFor=='ADMIN_PROVIDER'){
            <div class="gray-text fs-11 mt-1">
              {{ item.gender?.charAt(0) ||'-' }}
            </div>}
            <div class="gray-text fs-11 mt-1">
              {{ item.dateOfBirth |age}} 

            </div>
          </div>
        </div>
        @if(TableFor==='ADMIN_PROVIDER' ||  TableFor==='ADMIN_INSURER' || TableFor==='ADMIN_DISTRIBUTOR' ){
        <div class="fixed-with-coloumn p-2 ">
          <div class="fullname-wrapper gray-text">
            <div> {{item?.activeStartDate ||'-'}} - {{item?.activeEndDate || '-'}}</div>
            <!-- <div>  |{{item?.activeEndDate || '-'}}</div> -->
          </div>

        </div>}
        <!-- @if(TableFor==='ADMIN_INSURER'){
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.organisationName || '-'}} </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{item?.providers[0]?.name || '-'}} </div>
        } -->


        <div class="fixed-with-coloumn p-2 gray-text"> {{item.phone ||'-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.email || '-'}} </div>
                <div class="fixed-with-coloumn p-2 gray-text"> {{item.address || '-'}} </div>

       

        <div class="fixed-with-coloumn p-2 gray-text">
          <app-status-lables [entityType]="enumEntityType.INSURER" [status]="item.isactive?'ACTIVE':'DEACTIVE'">
          </app-status-lables>
        </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <div class="action-buttons d-flex align-items-center gap-2">
            @if (!item.isactive) {
            <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
              (click)="confirmStatusUpdateTrue.emit(item);$event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#53e643" fill-rule="evenodd"
                  d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
              </svg>
            </span>
            } @else {
            <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
              (click)="confirmStatusUpdateFalse.emit(item); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z" stroke-width="0.1"
                  stroke="#e84721" />
              </svg>
            </span>
            }
            @if(TableFor==='ADMIN_INSURER'){
            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>}

            @else if (TableFor==='ADMIN_PROVIDER') {

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>
            }

             @else if (TableFor==='ADMIN_DISTRIBUTOR') {

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>
            }
          </div>
        </div>






      </div>}

      @else if(TableFor==='INSURER_ORG' || TableFor==='PROVIDER_ORG' || TableFor==='DISTRIBUTOR_ORG' ){
      <div class="information-box border-colour" >
        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{ item.tradingName }} {{ item.lastName }}</div>
            @if ( TableFor=='INSURER_ORG'){
            <div class="gray-text fs-11 mt-1">
              {{ item.gender?.charAt(0) ||'-' }}
            </div>}
            <div class="gray-text fs-11 mt-1">
              {{ item.dateOfBirth |age}} ,{{item.gender?.charAt(0)}}

            </div>
          </div>
        </div>
        @if(TableFor==='INSURER_ORG' ||  TableFor==='PROVIDER_ORG' || TableFor==='DISTRIBUTOR_ORG' ){
        <div class="fixed-with-coloumn p-2 ">
          <div class="fullname-wrapper gray-text">
            <div>  {{item?.activeStartDate ||'-'}} -  {{item?.activeEndDate || '-'}}</div>
          </div>

        </div>}
        <!-- @if(TableFor==='ADMIN_INSURER'){
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.organisationName || '-'}} </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{item?.providers[0]?.name || '-'}} </div>
        } -->


        <div class="fixed-with-coloumn p-2 gray-text"> {{item.contactPhone ||'-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.email || '-'}} </div>
                <div class="fixed-with-coloumn p-2 gray-text"> {{item.address || '-'}} </div>

       

        <div class="fixed-with-coloumn p-2 gray-text">
          <app-status-lables [entityType]="enumEntityType.INSURER" [status]="item.isactive?'ACTIVE':'DEACTIVE'">
          </app-status-lables>
        </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <div class="action-buttons d-flex align-items-center gap-2">
            @if (!item.isactive) {
            <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
              (click)="confirmStatusUpdateTrue.emit(item);$event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#53e643" fill-rule="evenodd"
                  d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
              </svg>
            </span>
            } @else {
            <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
              (click)="confirmStatusUpdateFalse.emit(item); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z" stroke-width="0.1"
                  stroke="#e84721" />
              </svg>
            </span>
            }
            @if(TableFor==='INSURER_ORG'){
            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>}

            @else if (TableFor==='PROVIDER_ORG') {

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>
            }

             @else if (TableFor==='DISTRIBUTOR_ORG') {

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>
            }
          </div>
        </div>






      </div>
      }
      <!-- @if(TableFor==='ADMIN_DISTRIBUTOR'){

      <div class="information-box border-colour" (click)="openAdminDistributerProfile.emit(item.users?.[0].userId)">

        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{item.contactPerson}}</div>
            <div> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#64befe"
                  d="M14 13h5v-2h-5zm0-3h5V8h-5zm-9 6h8v-.55q0-1.125-1.1-1.787T9 13t-2.9.663T5 15.45zm4-4q.825 0 1.413-.587T11 10t-.587-1.412T9 8t-1.412.588T7 10t.588 1.413T9 12m-5 8q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20z" />
              </svg> {{item.fcaReferenceNumber || '-'}}</div>

          </div>



        </div>


        <div class="fixed-with-coloumn p-2 ">
          <div class="fullname-wrapper gray-text">
            <div> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#91caf3"
                  d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                  opacity="0.5" />
                <path fill="#91caf3"
                  d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
              </svg> | {{item?.activeStartDate || '-'}}</div>
            <div> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#91caf3"
                  d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                  opacity="0.5" />
                <path fill="#91caf3"
                  d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
              </svg> |{{item?.activeEndDate || '-'}}</div>
          </div>

        </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.contactPhone ||'-'}} </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{item.email || '-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.tradingName || '-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text">
          <button class="filter-btn active-filter"
            [ngClass]="item.isactive ?'Active':'in-Active'">{{item.isactive?'active':'Deactive'}}</button>

        </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <div class="action-buttons d-flex align-items-center gap-2">
            @if (!item.isactive) {
            <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
              (click)="confirmStatusUpdateTrue.emit(item);$event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#53e643" fill-rule="evenodd"
                  d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
              </svg>
            </span>
            } @else {
            <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
              (click)="confirmStatusUpdateFalse.emit(item); $event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z" stroke-width="0.1"
                  stroke="#e84721" />
              </svg>
            </span>
            }

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openAdminInsurerForm.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>


          </div>
        </div>













      </div>} -->



    </div>
  </div>



</div>